import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChallengesRoutingModule } from './challenges-routing.module';
import { ChallengesPage } from './pages/challenges/challenges.page';
import { SharedModule } from '../_shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChallengesAdminCardComponent } from './components/challenges-admin-card/challenges-admin-card.component';
import { ChallengesBaseCardComponent } from './components/challenges-base-card/challenges-base-card.component';
import { ChallengesDailyCardComponent } from './components/challenges-daily-card/challenges-daily-card.component';
import { ChallengesHistoryCardComponent } from './components/challenges-history-card/challenges-history-card.component';
import { ChallengesMonthlyCardComponent } from './components/challenges-monthly-card/challenges-monthly-card.component';
import { ChallengesDailyContentComponent } from './components/challenges-daily-card/components/challenges-daily-content/challenges-daily-content.component';
import {
  ChallengesMonthlyContentComponent
} from './components/challenges-monthly-card/components/challenges-monthly-content/challenges-monthly-content.component';
import { DailyDialogComponent } from './components/dialogs/daily-dialog/daily-dialog.component';
import { MonthlyDialogComponent } from './components/dialogs/monthly-dialog/monthly-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../_material/material.module';
import { ChallengesSkeletonComponent } from './components/challenges-skeleton/challenges-skeleton.component';


@NgModule({
  declarations: [
    ChallengesPage,
    ChallengesAdminCardComponent,
    ChallengesBaseCardComponent,
    ChallengesDailyCardComponent,
    ChallengesDailyContentComponent,
    ChallengesHistoryCardComponent,
    ChallengesMonthlyCardComponent,
    ChallengesMonthlyContentComponent,
    DailyDialogComponent,
    MonthlyDialogComponent,
    ChallengesSkeletonComponent,
  ],
  imports: [
    CommonModule,
    ChallengesRoutingModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChallengesModule { }
